import { BASE_API_URL } from "~/helper/apiService";

const normalizedBaseUrl =
  BASE_API_URL && BASE_API_URL.endsWith("/") ? BASE_API_URL : `${BASE_API_URL || ""}/`;

export const API_BASE = `${normalizedBaseUrl}api`;

// Helper fetch với credentials
export async function fetchWithAuth(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
}

